import dateHelper from '../../../helpers/date.js'
import Bus from '../../../main.js'

export default{
    sendSuggestion: ({commit, dispatch}, suggestion) => {
        dispatch('SET_SELF_SUGGESTION', suggestion)
    },
    saveStartGame: ({commit, dispatch}, startGame) => {
        let startGameMoment =  dateHelper.timestampToMoment(startGame)
        commit('SET_START_GAME', startGame)
        Bus.$emit('initClock')
    }
}